import Vue from 'vue'
import VueRouter from 'vue-router'
import Content from '../layouts/Content.vue'
import listenArticle from '../views/listenArticle'
import DigitalArticleMobile from '../layouts/DigitalArticleMobile'
Vue.use(VueRouter)

const routes = [
  {
    path: '/content',
    name: 'contentDefault',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: Content
  },
  {
    path: '/paperContent',
    name: 'paperContentDefault',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: Content
  },
  {
    path: '/listen',
    name: 'Listen',
    meta: {
      requiresAuth: false,
      title: ''
    },
    component: listenArticle
  },
  {
    path: '/digitalArticleMobile',
    name: 'digitalArticleMobile',
    meta: {
      requiresAuth: true,
      title: ''
    },
    component: DigitalArticleMobile
  },
  {
    path: '/',
   redirect:'/paperContent'
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  let url = window.location.href
  if (url.includes('?from=')) {
    // 判断是否携带了 from 参数，这一步灵活变通，只要能判断出是从微信分享链接进来的就 OK
    url = url.replace(/index.+.#/, 'index.html#') // 利用正则表达式去掉微信携带的 ?from=singlemessage&isappinstalled=0 这串参数，如果这串参数对于你当前的页面有用处的话，可以重新拼接到你正常的链接后面去
    window.location.href = url // 重定向到正常链接
  }
  next()
})

export default router
